import $http from '@/libs/axios'

export default class NotificationsApi {
  static async markAsRead(id: any) {
    return (await $http.post(`user/notifications/mark-read/${id}`, {})).data
  }

  static async notifications() {
    return (await $http.get('user/notifications')).data
  }

  static async delete(id: any) {
    return (await $http.delete(`user/notifications/delete/${id}`)).data
  }
}
